<template>
  <div :class="containerClasses">
    <div class="message-balloon__content">
      <div class="message-balloon__balloon py-2 px-3">
        <template v-if="hasImages">
          <img
            v-for="(image, index) in message.images"
            :key="index"
            class="message-balloon_image"
            :src="image"
            @click="emitClickImage(image)"
          />
        </template>
        <p v-else>{{ message.text }}</p>
      </div>

      <p class="message-balloon__time mr-1">{{ sentAt }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import moment from "moment";
import { Message } from "@/controller/chat";

export default defineComponent({
  name: "MessageBalloon",

  inheritAttrs: false,

  props: {
    message: {
      type: Object as PropType<Message>,
      required: true
    }
  },

  computed: {
    containerClasses(): string {
      const baseClass = "message-balloon";
      const classes = [baseClass];

      if (this.isMe) {
        classes.push(`${baseClass}--is-me`);
      }

      return classes.join(" ");
    },

    isMe(): boolean {
      return this.message.isFromCustomer;
    },

    sentAt(): string {
      return moment(this.message.date).fromNow();
    },

    hasImages(): boolean {
      return !!this.message.images;
    }
  },

  methods: {
    emitClickImage(image: string) {
      this.$emit("click:image", image);
    }
  }
});
</script>

<style lang="scss" scoped>
.message-balloon {
  display: flex;
  justify-content: flex-start;

  .message-balloon__balloon {
    background: $white;
  }

  &--is-me {
    justify-content: flex-end;

    .message-balloon__balloon {
      background: $black;
      color: $white;
    }
  }
}

.message-balloon__content {
  max-width: 75%;
  text-align: right;
}

.message-balloon__balloon {
  display: inline-block;
  border: 1px solid $black;
  border-radius: 15px;
  text-align: left;
  font-size: 0.9rem;
}

.message-balloon__time {
  font-size: 0.6rem;
}

.message-balloon_image {
  max-width: 100%;
}
</style>
